import React, { useState } from "react"

import type { SwiperOptions } from "swiper"
import { Swiper, SwiperSlide } from "swiper/react"
import LazyLoad from "react-lazyload"
import Container from "@ecom/ui/components/Container"
import Box from "@material-ui/core/Box"

import clsx from "clsx"
import * as styles from "./partners.module.scss"
import { PartnersProps } from "./types"
import { data } from "./helpers/data"
import { DLClickEventExtended } from "../../../helpers/WatcherDL/DLEvents"

const params: SwiperOptions = {
  slidesPerView: "auto",
}

const defaultDescription = (
  <>
    Более 260 000 магазинов-партнеров по&nbsp;всей стране: совершайте покупки в&nbsp;рассрочку*
    <br className="d-none d-md-block" /> и&nbsp;вносите платежи равными&nbsp;частями
  </>
)

export function Partners({
  orderNum,
  headTitle = "Покупайте в любимых магазинах",
  headDescr = defaultDescription,
  variant = "standart",
}: PartnersProps) {
  const [activeCategory, setActiveCategory] = useState(data[0]?.category || "")

  const handleClickCategory = (urlName: string) => {
    DLClickEventExtended({ name: urlName, eventAction: "Выбор категории", placement: "partners" })

    setActiveCategory(urlName)
  }

  const activeShops = data.find((item) => item.category === activeCategory)?.shops || []

  const renderCategories = () => (
    <ul className={styles.categoryList}>
      {data.map((item) => (
        <button
          type="button"
          onClick={() => handleClickCategory(item.category)}
          className={clsx(
            styles.category,
            activeCategory === item.category && styles.activeCategory
          )}
        >
          {item.category}
        </button>
      ))}
    </ul>
  )

  const renderShops = () => (
    <Swiper key={activeCategory} {...params}>
      {activeShops.map((item) => (
        <SwiperSlide className={styles.slide} key={item.name}>
          <Box className="text-center">
            <Box display="flex" alignItems="center" justifyContent="center" className={styles.logo}>
              <LazyLoad offset={100} once>
                <img alt={item.name} src={item.image} />
                <p>{item.name}</p>
              </LazyLoad>
            </Box>
          </Box>
        </SwiperSlide>
      ))}
    </Swiper>
  )

  return (
    <section className={clsx(styles.section, variant)} id="partners" data-exclude={orderNum}>
      <Container className={styles.container}>
        <div className={styles.title_container}>
          <h2 className={styles.headTitle}>{headTitle}</h2>
          {headDescr && <p className={styles.headDescr}>{headDescr}</p>}
        </div>
        {renderCategories()}
        <section className="content-visibility-auto">
          <div>
            <Container className={styles.p_0}>{renderShops()}</Container>
          </div>
        </section>
      </Container>
    </section>
  )
}
